module.exports = __webpack_public_path__ + "img/dongus.d788cc61.png";